import { useLayoutEffect, useState, type RefObject } from "react";
import { resolveSubmenuPlacement } from "../sections/HeaderV2/logic";

type SubmenuPlacement = { shift: number; drop: number };

export const useSubmenuPlacement = ({ panelRef }: { panelRef: RefObject<HTMLElement | null> }): SubmenuPlacement => {
  const [placement, setPlacement] = useState<SubmenuPlacement>({ shift: 0, drop: 0 });

  useLayoutEffect(() => {
    const panel = panelRef.current;
    const item = panel?.parentElement;
    const bounds = item?.closest("nav")?.parentElement;
    if (!panel || !item || !bounds) return;

    const measure = () => {
      const itemRect = item.getBoundingClientRect();
      const boundsRect = bounds.getBoundingClientRect();
      const scale = item.offsetWidth > 0 && itemRect.width > 0 ? itemRect.width / item.offsetWidth : 1;
      const next = resolveSubmenuPlacement({
        item: { left: itemRect.left / scale, bottom: itemRect.bottom / scale },
        panelWidth: panel.offsetWidth,
        bounds: { left: boundsRect.left / scale, right: boundsRect.right / scale, bottom: boundsRect.bottom / scale },
      });
      setPlacement((current) => (current.shift === next.shift && current.drop === next.drop ? current : next));
    };

    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(bounds);
    return () => observer.disconnect();
  }, [panelRef]);

  return placement;
};
